import RefreshIcon from '@mui/icons-material/Refresh'
import { Box, Button, Stack, Typography } from '@mui/material'

import { useNewVersion } from '../version/useNewVersion'
import { useWorkInFlight } from '../version/useWorkInFlight'

/**
 * Says a newer version is being served, and offers the reload.
 *
 * Not dismissible: dismissing it is how a tab quietly stays on a build whose
 * assumptions about the API no longer hold. It does wait for uploads and order
 * submissions to finish first -- reloading mid-upload abandons the unsent
 * chunks, and a reload button sitting next to work in progress invites exactly
 * that.
 */
export default function NewVersionBar() {
  const stale = useNewVersion()
  const { busy } = useWorkInFlight()

  if (!stale || busy) return null

  return (
    <Box
      sx={{
        px: 3,
        py: 1,
        bgcolor: 'primary.dark',
        color: 'primary.contrastText',
        borderBottom: 1,
        borderColor: 'divider',
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
        <Typography variant="body2">
          A newer version of taikapeili is available. Reload to pick it up.
        </Typography>
        <Button
          size="small"
          variant="contained"
          color="inherit"
          startIcon={<RefreshIcon />}
          // Not reload(true): that argument has been ignored for years. The
          // document is served no-cache, so a plain reload fetches the new one.
          onClick={() => window.location.reload()}
          sx={{ color: 'primary.dark', bgcolor: 'primary.contrastText', flexShrink: 0 }}
        >
          Reload
        </Button>
      </Stack>
    </Box>
  )
}
